jQuery(function($) {

	function gtmAddEvent(evName, options) {
		if ( !options ) options = {}
		options.event = evName+'-event';
		var gdpr = getCookie('gdpr'), gtm_enabled = 0;
		if ( gdpr ) {
			var services = gdpr.split('!');
			for (var i=0;i<services.length;i++) {
				var service_info = services[i].split('=');
				if ( service_info[0] == 'googletagmanager' ) {
					if ( service_info[1] == 'true' ) {
						gtm_enabled = 1;
						break;
					}
				}
			}
			// console.log(services);
		}
		if ( gtm_enabled ) {
			// console.log(options);
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(options);
			// console.log(gdpr);
			// console.log(options);
		} else {
			// console.log('GTM disabled');
		}
	}

	var formHasChanges = 0;
	if ( jQuery('.gform_wrapper form').length > 0 ) {
		//we have a gf form, we must check fields
		jQuery('.gform_wrapper form').find('select, input, textarea').on('change', function(e) {
			formHasChanges = 1;
		});

		jQuery(window).bind('beforeunload', function(){
			// console.log('HasChanges: ' + formHasChanges);
			if ( formHasChanges ) {
				var formID = jQuery('.gform_wrapper form').attr('id').replace('gform_', '');
				// console.log(formID);
				sendGTMEventsForForm(formID, 14, '-Unload-Page');
			}
		});
	}

	// console.log(14 & 1);
	// console.log(14 & 2);
	// console.log(14 & 4);
	// console.log(14 & 8);

	var gtmForms = cht_wp.fgtm;
	var l_gtmEv = '';


	jQuery(document).on('change', '.gfield.gtm-event select', function(e) { l_gtmEv = jQuery(this).val(); });
	jQuery(document).bind("gform_confirmation_loaded", function(event, formID) { console.log('confirmation_loaded'); sendGTMEventsForForm(formID, 15); });

	function sendGTMEventsForForm(formID, what2Load, eventNameSuffix, curl) {
		if ( !eventNameSuffix ) eventNameSuffix = '';
		if ( !curl ) curl = cht_wp.curl;
		// console.log('Newsletter: '+gtmForms.news.indexOf(formID+"")+' / what2Load: '+(what2Load & 1));
		if ( gtmForms.news.indexOf(formID+"") >= 0 && (what2Load & 1) == 1 ) {
			gtmAddEvent('Submit-Newsletter-Footer'+eventNameSuffix, {
				'eventCategory': 'Inscription-Newsletter-Footer',
				'eventAction': 'Submit-Newsletter-Footer',
				'eventLabel': curl,
			});
		}

		// console.log('Contact: '+gtmForms.contact.indexOf(formID+"")+' / what2Load: '+(what2Load & 2));
		if ( gtmForms.contact.indexOf(formID+"") >= 0 && (what2Load & 2) == 2 ) {
			// console.log('Contact');
			gtmAddEvent('Submit-Contact-Form'+eventNameSuffix, {
				'eventCategory': 'Contact-Form-Send',
				'eventAction': 'Submit-Contact-Form',
				'eventLabel': l_gtmEv,
			});
		}
		// console.log('Livre: '+gtmForms.livre.indexOf(formID+"")+' / what2Load: '+(what2Load & 4));
		if ( gtmForms.livre.indexOf(formID+"") >= 0 && (what2Load & 4) == 4 ) {
			// console.log('Livre');
			gtmAddEvent('Submit-Form-Livre-Blanc'+eventNameSuffix, {
				'eventCategory': 'Form-Livre-Blanc',
				'eventAction': 'Submit-Form-Livre-Blanc',
				'eventLabel': curl,
			});
		}
		// console.log('Event: '+gtmForms.event.indexOf(formID+"")+' / what2Load: '+(what2Load & 8));
		if ( gtmForms.event.indexOf(formID+"") >= 0 && (what2Load & 8) == 8 ) {
			gtmAddEvent('Submit-Form-Evenement'+eventNameSuffix, {
				'eventCategory': 'Form-Evenement',
				'eventAction': 'Submit-Evenement',
				'eventLabel': curl,
			});
		}
	}


	// gtmAddEvent('test', {'test':'test1'});
});
